module.exports = __webpack_public_path__ + "img/work-1.aecbb61b.png";